import { render, staticRenderFns } from "./UIIndicadores.vue?vue&type=template&id=3100c451&scoped=true"
import script from "./UIIndicadores.vue?vue&type=script&lang=js"
export * from "./UIIndicadores.vue?vue&type=script&lang=js"
import style0 from "./UIIndicadores.vue?vue&type=style&index=0&id=3100c451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3100c451",
  null
  
)

export default component.exports